var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.user.privilege === 'agent')?_c('agent-profile'):(_vm.user.privilege === 'rep')?_c('rep-profile'):_c('member-profile')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }